var api_url = "http://192.168.2.10:3068/api/"
var socket_url = 'http://192.168.2.10:3068'
// api_url ="https://devapi.360inventory.app/api/"
var server = false;
const isProductionBuild = process.env.NODE_ENV === "production";

if (isProductionBuild) {
    server = true;
} else if (window.location.host.includes("sipro.store")) {
    server = true;
}


if (server) {
    api_url = "https://api.sipro.app/api/"
    socket_url = 'https://api.sipro.app'
}

// Host dùng khi test local (thay bằng domain shop cần test)
const dev_shop_host = isProductionBuild ? null : 'si.thuytienfood.vn';
//const dev_shop_host = isProductionBuild ? null : 'si.thuytienfood.vn';
export { api_url, socket_url, dev_shop_host };